'use strict'

module.exports.BI_ENDPOINT = 'platform'
module.exports.BI_CM_ENDPOINT = 'platform-cm'
module.exports.BI_SANTA_EDITOR_ENDPOINT = 'editor'
module.exports.BI_VIEWER_ENDPOINT = 'platform-viewer'
module.exports.BI_ERROR_ENDPOINT = 'trg'
module.exports.BI_SOURCE = 79
module.exports.BI_CM_SOURCE = 83
module.exports.BI_SANTA_EDITOR_SOURCE = 38
